export const SGA_SESSION_LIMIT_UPDATE_ALERT_ID = "SGA_SESSION_LIMIT_UPDATE_ALERT_ID";
export const SGA_SESSION_LIMIT_REMOVE_ALERT_ID = "SGA_SESSION_LIMIT_REMOVE_ALERT_ID";
